// src/components/store/sections/product-cards/Variant74TiltedGallerySunsetAmberCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, ShoppingBag, Heart, Check } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant74TiltedGallerySunsetAmberCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    comparePrice,
    added,
    wishlisted,
    setWishlisted,
    handleAddToCart,
  } = useCardActions(product, subdomain);

  return (
    <div className="relative w-full h-full p-1.5 select-none group">
      <div className="absolute inset-2 rounded-[28px] bg-gradient-to-br from-amber-500 to-orange-600 opacity-25 rotate-2 group-hover:rotate-6 transition-transform pointer-events-none" />
      <div className="relative z-10 w-full h-full bg-white rounded-[26px] border-2 border-amber-200 p-3.5 shadow-md group-hover:shadow-xl transition-all flex flex-col justify-between">
        <div>
          <div className="relative w-full h-44 rounded-2xl bg-amber-50 border border-amber-200 overflow-hidden flex items-center justify-center p-3 mb-3">
            <span className="absolute top-2 left-2 px-2.5 py-0.5 rounded-md bg-white/90 text-amber-800 font-mono font-black text-xs shadow-2xs">
              ৳{currentPrice.toLocaleString()}
            </span>
            <button
              type="button"
              onClick={() => setWishlisted(!wishlisted)}
              className="absolute top-2 right-2 w-7 h-7 rounded-full bg-white/90 flex items-center justify-center text-slate-400 hover:text-rose-500 cursor-pointer"
            >
              <Heart className={`w-3.5 h-3.5 ${wishlisted ? "fill-rose-500 text-rose-500" : ""}`} />
            </button>
            <Link href={productUrl} className="relative w-36 h-36 block">
              <Image src={productImg} alt={productName} fill unoptimized className="object-contain group-hover:scale-110 transition-transform duration-500" />
            </Link>
          </div>
          <span className="text-[9px] font-black uppercase tracking-widest text-amber-800 block truncate">{categoryName}</span>
          <Link href={productUrl} className="block mt-0.5">
            <h3 className="text-sm font-black text-slate-900 truncate hover:underline">{productName}</h3>
          </Link>
          <div className="flex items-center justify-between mt-1">
            <div className="flex items-center gap-0.5 text-amber-400 text-xs">
              <Star className="w-3.5 h-3.5 fill-amber-400" />
              <span className="font-bold text-slate-600 text-[11px]">{rating.toFixed(1)}</span>
            </div>
            {comparePrice > currentPrice && (
              <span className="text-[10px] text-slate-400 line-through font-mono">৳{comparePrice.toLocaleString()}</span>
            )}
          </div>
        </div>
        <button
          type="button"
          onClick={(e) => handleAddToCart(e)}
          className="w-full mt-3 py-2.5 rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-black text-[10px] uppercase tracking-wider shadow-sm active:scale-95 transition-all cursor-pointer flex items-center justify-center gap-1.5"
        >
          {added ? <Check className="w-3.5 h-3.5" /> : <ShoppingBag className="w-3.5 h-3.5" />}
          <span>{added ? "Added" : "Add to Stack"}</span>
        </button>
      </div>
    </div>
  );
}
